module.exports = __webpack_public_path__ + "img/Diseño-SItio-web_03.2c969fdf.jpg";